import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "題目",
    isNumber: true,
    isSum: true,
    isControl: true,
  },
  {
    key: "選項",
    isNumber: true,
    isSum: true,
  },
];

const groupOrders = {
  教育: {
    不識字: 0,
    國小: 1,
    國中: 2,
    高中: 3,
    大專院校: 4,
    研究所以上: 5,
    其他: 6,
    "-": 7,
  },
};

export const EducationLevelToWeightWaistManagement = {
  label: "教育程度 vs 體重及腰圍管理",
  key: "EducationLevelToWeightWaistManagement",
  path: "BMI/EducationLevelToWeightWaistManagement",
  api: "TCS_V_BMIHEBMIV",
  render: (options) => (
    <Diagram.BMI.EducationLevelToWeightWaistManagement {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "教育",
      field: "教育",
      header: "",
    },
  ],
  groupOrders,
  levelColumns,
  columns: [],
};
